import { HotelDetails } from './HotelDetails';

export default HotelDetails;
